var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrowWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4702_831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6264 4.87361L13.513 4.87363C13.6165 4.87373 13.7157 4.91489 13.7889 4.98806C13.8621 5.06123 13.9032 5.16044 13.9034 5.26393L13.9034 7.15057C13.9027 7.23449 13.8689 7.31475 13.8094 7.37386C13.7498 7.43297 13.6693 7.46614 13.5854 7.46613C13.5014 7.46613 13.4209 7.43296 13.3614 7.37385C13.3018 7.31474 13.268 7.23447 13.2674 7.15056L13.2673 5.95935L9.88291 9.34377L9.43313 8.89398L12.8175 5.50957L11.6264 5.50957C11.5429 5.50831 11.4632 5.47424 11.4046 5.41474C11.346 5.35525 11.3132 5.27508 11.3132 5.19157C11.3132 5.10806 11.346 5.0279 11.4046 4.96841C11.4633 4.90892 11.5429 4.87487 11.6264 4.87361ZM8.6671 9.66002L5.11798 13.2091V12.018C5.11672 11.9345 5.08265 11.8548 5.02316 11.7962C4.96366 11.7376 4.88349 11.7048 4.79998 11.7048C4.71647 11.7048 4.63632 11.7376 4.57682 11.7962C4.51733 11.8548 4.48328 11.9345 4.48202 12.018L4.48204 13.9046C4.48216 14.0081 4.52332 14.1073 4.59648 14.1805C4.66964 14.2536 4.76884 14.2948 4.8723 14.2949L6.75891 14.2949C6.84253 14.2938 6.92235 14.2599 6.98109 14.2003C7.03984 14.1408 7.07278 14.0606 7.07279 13.977C7.07279 13.8933 7.03986 13.8131 6.98113 13.7536C6.92239 13.694 6.84258 13.6601 6.75897 13.6589L5.56776 13.6589L9.11688 10.1098L8.6671 9.66002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4702_831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 9.58423) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrowWhite);
export default __webpack_public_path__ + "static/media/expand-arrow-white.3d3e064649dbf74a43c0d24eb09ca7cc.svg";
export { ForwardRef as ReactComponent };